import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import React, { useEffect, useState } from "react";

import useAppStore from "@/store/use-app-store";
import { CssBaseline } from "@mui/material";
import { getLocalStorageItem, isIdentical } from "data/functions";

export const ThemeContext = React.createContext();

// import { useThemeParameters } from "@vkruglikov/react-telegram-web-app";
// const initialState = {
//   theme: THEMES.DEFAULT,
//   setTheme: (theme) => {},
// };

// const ColorModeContext = React.createContext({
//   toggleColorMode: () => {},
// });

const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});

export const GetColorMode = () => {
  const context = React.useContext(ColorModeContext);
  return context;
};

function ThemeProvider({ children }) {
  const [mode, setMode] = useState();
  const [bgColor, setBgColor] = useState("#fff");

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((previousMode) =>
          previousMode === "light" || !previousMode ? "dark" : "light",
        );
      },
    }),
    [],
  );

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });

  const theme = React.useMemo(
    () =>
      createTheme({
        breakpoints: {
          values: {
            mobile: 380,
            pc: 1400,
            tablet: 900,
            xs: 0,
          },
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              "*::-webkit-scrollbar": {
                display: "none",
                height: "0.6rem",
                width: "0.4rem",
              },
              "*::-webkit-scrollbar-thumb": {
                backgroundColor: "#6b6b6b",
                borderRadius: "8px",
                // visibility: "hidden",
              },
              "*::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
                {
                  backgroundColor: "#959595",
                  // visibility: "visible",
                },
              "*::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
                {
                  backgroundColor: "#959595",
                },
              "*::-webkit-scrollbar-thumb:hover": {
                background: "#aaa",
              },
              "*::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
                {
                  backgroundColor: "#959595",
                },
              "*::-webkit-scrollbar-track": {
                background: "transparent",
                borderRadius: "8px",
              },
              "*::-webkit-scrollbar:active": {
                display: "block",
              },
              "*:hover::-webkit-scrollbar:hover": {
                display: "block",
              },
              scrollbarColor: "#6b6b6b transparent",
            },
          },
          MuiPaper: {
            styleOverrides: {
              root: {
                background: bgColor ?? undefined,
              },
            },
          },
          MuiTabs: {
            styleOverrides: {
              indicator: {
                backgroundColor: `${mode === "light" ? "#000" : "#fff"}!important`,
              },
              root: {
                ".Mui-selected": {
                  // backgroundColor: "#434343!important",
                  color: `${mode === "light" ? "#000" : "#fff"}!important`,
                },
                ".MuiTab-root": {
                  // backgroundColor: "#434343!important",
                  color: `${mode === "light" ? "#838383" : "#434343"}`,
                },
                marginBottom: "4px",
                marginTop: "4px",
                // color: "#434343!important",
                // background: bgColor ? bgColor : undefined,
              },
            },
          },
          MuiUseMediaQuery: {
            defaultProps: {
              noSsr: true,
            },
          },
        },
        palette: {
          background: {
            default: bgColor ?? undefined,
          },
          dimblue: createColor("#2b74bd"),
          dimdarkgreen: createColor("#446b54"),
          dimdarkred: createColor("#5d1616"),
          dimgreen: createColor("#378b59"),
          dimgrey: createColor("#434343"),
          dimred: createColor("#c32929"),
          lightred: createColor("#ef7d7d"),
          mode: mode ?? undefined,
          primary: {
            main: "#434343",
          },
          white: createColor("#fff"),
        },
        spacing: 2,
        typography: {
          // In Chinese and Japanese the characters are usually larger,
          // so a smaller fontsize may be appropriate.
          fontSize: 14,
        },
      }),
    [mode, bgColor],
  );
  theme?.spacing(2);

  useEffect(() => {
    const { themeMode } = useAppStore.getState();
    if (mode) {
      if (!isIdentical(themeMode, mode))
        useAppStore.setState({ themeMode: mode });

      let newBg = mode === "light" ? "#fff" : "#161c23";
      if (!isIdentical(bgColor, newBg)) setBgColor(newBg);
    } else {
      let newMode =
        themeMode ??
        (window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light");
      setMode(newMode);
    }
  }, [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={responsiveFontSizes(theme)}>
        <CssBaseline />
        <ThemeContext.Provider value={""}>{children}</ThemeContext.Provider>
        {/* {children} */}
      </MuiThemeProvider>
    </ColorModeContext.Provider>
  );
}

export { ThemeProvider };
